// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Thumbnail_wrapper__UUt_w","thumbnail":"Thumbnail_thumbnail__mDVoT","icon":"Thumbnail_icon__qPoPE","title":"Thumbnail_title__2kiWE"};